/**
 * RelevanceCheckmark — read-only relevance indicator used by every
 * Child TARAs table (Steps 2-8). Mirrors legacy `ChildAssetsSection`
 * (line 283-287) — green check when relevant, empty cell when not.
 *
 * Rendered when the parent `Edit Relevance` toggle is OFF. When ON,
 * each child table swaps this for an editable `<input type=checkbox>`.
 */
import React from 'react';
import { Icon } from '../../../components/ui/Icon';

export interface RelevanceCheckmarkProps {
  /** Renders the green check when truthy. Falsy → empty cell. */
  relevant: boolean | undefined;
}

export default function RelevanceCheckmark({ relevant }: RelevanceCheckmarkProps) {
  if (relevant === false) return null;
  return (
    <span
      aria-label="Relevant"
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        color: 'var(--color-status-success)',
      }}
    >
      <Icon name="check" size={16} />
    </span>
  );
}
